import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Poll } from '@app/models/poll';
import * as PollsActions from '@app/store/features/polls/polls.actions';

export interface State extends EntityState<Poll> {

}

export const adapter: EntityAdapter<Poll> = createEntityAdapter<Poll>({
    selectId: (model: Poll) => model.id,
});

export const initialState: State = adapter.getInitialState({

});

export const reducer = createReducer(initialState,
    on(PollsActions.setAll, (state, { polls }) => {
        return adapter.setAll(polls, state);
    }),
    on(PollsActions.removeOne, (state, { pollId }) => {
        return adapter.removeOne(pollId, state);
    }),
);
